<template>
  <div class="customer-login">
    <h3 class="title">{{$t('WelcomeToMaxain')}}</h3>
    <p class="tips">{{$t('please_sign_in')}}</p>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      hide-required-asterisk
    >
      <el-form-item
        :label="$t('Account')"
        prop="username"
      >
        <el-input
          :placeholder="`${$t('mobile_phone')}/${$t('email')}`"
          v-model.trim="form.username"
          name="username"
          class="w-full">
        </el-input>
      </el-form-item>
      <el-form-item
        prop="password"
        class="password-form-item"
      >
        <p class="text-p display-flex space-between">
          <span>{{$t('password')}}</span>
          <span
            @click="resetPasswordHandle"
            class="reset-password theme-color pointer"
          >{{$t('resetPass')}}</span>
        </p>
        <el-input
          type="password"
          :placeholder="$t('password')"
          v-model.trim="form.password"
          show-password
          @keyup.enter.native="loginHandle"
          class="w-full"></el-input>
      </el-form-item>
      <el-form-item>
        <vs-button
          class="w-full mt-6 vs-button-outer"
          type="filled"
          size="large"
          :disabled="loginLoading"
          @click="loginHandle"
        >
          <span v-if="loginLoading"><i class="el-icon-loading"></i> </span>
          {{$t('Log_in')}}
        </vs-button>
      </el-form-item>
    </el-form>
    <p class="center">
      {{$t('No_account_yet')}}? <span class="theme-color pointer" @click="toRegister">{{$t('GoToRegister')}}</span>
    </p>
  </div>
</template>

<script>
import { setLocalStorage } from '@/utils/common';
import { LoginPost,queryNoticeDialog } from '@/api/user'
import MD5 from 'js-md5'
import { Object } from 'core-js';
export default {
  name: "customerLogin",
  data() {
    let _this = this;
    return {
      form:{
        username: '',
        password: '',
      },
      rules:{
        username: [
          { required: true, message: (_this.$t('please_input') + _this.$t('Account')), trigger: 'blur' }
        ],
        password: [
          { required: true, message: _this.$t('Please_enter_password'), trigger: 'blur' }
        ],
      },
      loginLoading: false,
    }
  },
  methods: {
    resetPasswordHandle() {
      this.$router.push({name: 'resetPassword'});
    },
    setCustomerDashboard(){
      localStorage.setItem('agentRole', 'CUSTOMER');
      this.$store.commit('setAgentRole','CUSTOMER');
    },
    loginHandle(){
      if (this.loginLoading) return;
      this.$refs.form.validate((valid) => {
        if(valid){
          this.loginLoading = true;
          LoginPost({
            username: this.form.username,
            password: MD5(this.form.password),
            // googleKey: this.form.dynamicpassword,
          }).then((res) => {
            let content = res.data;
            localStorage.setItem('token',content.token);

            this.$store.commit('setUserInfo', content.cust);
            localStorage.setItem('userInfo',JSON.stringify(content.cust));

            // 10 未填资料开户,未激活

            //如果是代理系统,
            if(content.cust.custType == 1){
              this.setCustomerDashboard();
            }else {
              this.setCustomerDashboard();
            }

            let targetRoute;
            if (content.cust.custStatus == 1) {
              targetRoute = { name: 'perfectInfo' };
            } else {
              if (this.$route.query.redirectRouterName) {
                if(Object.keys(this.$route.query).length > 1){
                  let queryParams = this.$route.query;
                  let redirectQuery = {};
                  for (const key in queryParams) {
                    if (queryParams.hasOwnProperty(key)) {
                        if(key!= "redirectRouterName"){
                          redirectQuery[key] = queryParams[key];
                        }
                    }
                  }
                  targetRoute = { name: this.$route.query.redirectRouterName, parmas: this.$route.params ,query:redirectQuery};
                }else{
                  targetRoute = { name: this.$route.query.redirectRouterName, parmas: this.$route.params };
                }
              } else {
                targetRoute = { name: 'dashboard' };
              }
            }
            this.$router.push(targetRoute).catch(() => {
              window.location.href = this.$router.resolve(targetRoute).href;
            });
          }).catch((error) => {
            this.loginLoading = false;
            this.$emit('login-success');
          })
        }else {
          console.log('no-pass');
        }
      });
    },
    toRegister(){
      this.$router.push({name: 'register'});
    },
  },
}
</script>

<style lang="scss" scoped>
.customer-login {
  /deep/ .el-input__inner {
    border: 1px solid #D8D6DE;
    border-radius: 5px;
  }
  /deep/ .el-form-item__content {
    line-height: 10px;
  }
  /deep/ .el-form-item {
    margin-bottom: 15px;
  }
  /deep/ .el-form-item__label {
    padding-bottom: 5px;
    line-height: 14px;
  }
  .text-p {
    margin-bottom: 7px;
    margin-top: 7px;
  }
  .tips {
    margin-bottom: 40px;
    margin-top: 10px;
  }
  .vs-button-outer {
    button {
      //font: none;
    }
  }
}
</style>
